/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { SimpleListFacet } from '~adapters/components/facets/SimpleListFacet';
import { LINKED_TICKET_STATUSES } from '../helpers';

export interface LinkedIssueStatusFacetProps {
  fetching: boolean;
  onChange: (changes: Record<string, Array<(typeof LINKED_TICKET_STATUSES)[number]>>) => void;
  onToggle: (property: string) => void;
  open: boolean;
  stats: Record<string, number> | undefined;
  statuses: string[];
}

export function LinkedIssueStatusFacet(props: Readonly<LinkedIssueStatusFacetProps>) {
  const { statuses, ...rest } = props;

  return (
    <SimpleListFacet
      possibleValues={LINKED_TICKET_STATUSES}
      property="linkedTicketStatus"
      translationKey="issues.facet.linkedTicketStatus"
      values={statuses}
      {...rest}
    />
  );
}
